<script>
    import { link } from "svelte-spa-router";
    import CookbookService from "../server/service/CookbookService";

    export let params;
    let data = undefined;

    async function fetchData() {
        try {
            return await CookbookService.get(params.id);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    data = fetchData();
</script>

<style>
</style>

{#await data}
    <p>Loading...</p>
{:then cookbook}
    <article class="cookbook">
        <h1>Edit {cookbook.title}</h1>
        <p>{cookbook.created}</p>
        <p>{cookbook.description}</p>
        <ol>
            {#each cookbook.recipes as recipe}
                <li>
                    <a href="/recipes/{recipe.id}" use:link>[{recipe.id}] {recipe.title}</a>
                </li>
            {/each}
        </ol>
    </article>
{:catch error}
    <p style="color: red">{error.message}</p>
{/await}